import { Backdrop, CircularProgress, Stack, Typography, useTheme } from "@mui/material";

const LoadingComponent = ({ title, open }) => {
  const theme = useTheme();
  return (
    <Backdrop
      sx={{
        position: "absolute",
        color: theme.palette.primary.main,
        zIndex: `${(theme) => theme.zIndex.drawer + 1500} !important`,
        margin: "0 !important",
        "&.MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        },
      }}
      open={open}
    >
      <Stack sx={{ justifyContent: "center", alignItems: "center" }}>
        <CircularProgress color="inherit" size="1rem" />
        {/*<Typography variant="caption" m={2}>*/}
        {/*  {title}*/}
        {/*</Typography>*/}
      </Stack>
    </Backdrop>
  );
};

export default LoadingComponent;
